// Locale resolution — the SAME contract as the inline pre-paint script in
// index.html and as the doctor client's src/i18n/config.js: stored choice
// ('parsina.locale') → device language → English. Keep the three in step.
//
// A deliberately small implementation of that contract: resolution is the only
// part of i18n this app needs that the doctor client's src/i18n/ also has, and
// the rest of that module (namespace-per-file, a lazy loader) buys nothing for
// six screens and one bundle — see catalogs.js. It is a candidate for promotion
// to @parsina/framework once a third client wants the same three lines; until
// then, do not fork the doctor client's version, and keep this contract
// identical to it and to the pre-paint script in index.html.

// `fr` and `de` need the kit at v0.24.0 or later (README «French release
// order», which holds for German too): on an older pin every kit-owned surface
// — pager, date picker, currency names, parseAmount — falls back to PERSIAN
// under lang=fr / lang=de. Do not ship this list with the v0.21.0 pin.
export const SUPPORTED = { fa: 'rtl', en: 'ltr', fr: 'ltr', de: 'ltr' };
export const STORAGE_KEY = 'parsina.locale';
export const FALLBACK = 'en';

/** Narrow any BCP-47-ish tag to a supported locale, or null. */
export function narrow(tag) {
  if (!tag) return null;
  if (SUPPORTED[tag]) return tag;
  const base = String(tag).toLowerCase().split(/[-_]/)[0];
  return SUPPORTED[base] ? base : null;
}

/** Resolve the active locale: stored → device → English. */
export function resolveLocale(storage, languages) {
  let stored = null;
  try {
    stored = narrow(storage?.getItem(STORAGE_KEY));
  } catch {
    /* storage off */
  }
  if (stored) return stored;
  for (const tag of languages || []) {
    const hit = narrow(tag);
    if (hit) return hit;
  }
  return FALLBACK;
}
